import CoreAppService from '../_shared/api/coreAppService';
import Singleton from '../Singleton';
import { DisclosureType } from '../global.d';

export default class DisclosureService extends Singleton<DisclosureService> {
  /**
   * Public Methods
   */
  static listDisclosures = async (tradeId: number, type: DisclosureType) => {
    if (!tradeId) {
      return null;
    }
    let disclosures;
    try {
      const client = await CoreAppService();
      disclosures = await client.disclosure.listDisclosures(type, tradeId);
    } catch (exp) {
      return exp?.response?.data;
    }

    return disclosures?.data;
  };
}
